import React from 'react'

import LancamentoPagamentoFormPageContainer from './LancamentoPagamentoFormPageContainer'

export class LancamentoPagamentoFormPage extends React.Component {
  render() {
    return <LancamentoPagamentoFormPageContainer {...this.props} />
  }
}
